import { useSubscriptionStore } from '@/features/auth/stores/subscription.store';
import { AlertCircle } from 'lucide-react';
import { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import ahiLogoWhite from '../../../../assets/images/ahiLogoWhite.png';

export const SidebarHeader = () => {
  const { isSubscribed, currentPeriodEnd, createSubscription, checkSubscription, status } =
    useSubscriptionStore();
  const [isUpgrading, setIsUpgrading] = useState(false);

  useEffect(() => {
    checkSubscription();
  }, []);

  const formatDate = (date: Date) => {
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
    }).format(date);
  };

  const handleUpgrade = async () => {
    try {
      setIsUpgrading(true);
      const checkoutUrl = await createSubscription();
      window.location.href = checkoutUrl;
    } catch (error) {
      console.error('Subscription error:', error);
      toast.error('Failed to create subscription. Please try again.');
    } finally {
      setIsUpgrading(false);
    }
  };

  return (
    <div className="p-4 border-b border-gray-700">
      <div className="flex items-center justify-center mb-4">
        <img src={ahiLogoWhite} alt="Logo" className="h-10" />
      </div>
      <div className="text-center space-y-2">
        <span
          className={`px-2 py-1 text-xs rounded-full ${
            isSubscribed ? 'bg-green-900 text-green-200' : 'bg-yellow-900 text-yellow-200'
          }`}
        >
          {isSubscribed ? 'Pro Plan' : 'Free Plan'}
        </span>
        {isSubscribed &&
          currentPeriodEnd &&
          (status === 'active_until_period_end' || status === 'cancelled') && (
            <div className="flex items-center justify-center gap-1 text-xs text-yellow-200">
              <AlertCircle className="h-3 w-3" />
              <span>
                {status === 'active_until_period_end'
                  ? `Active until ${formatDate(currentPeriodEnd)}`
                  : 'Subscription ended'}
              </span>
            </div>
          )}
        {(!isSubscribed || status === 'active_until_period_end' || status === 'cancelled') && (
          <button
            onClick={handleUpgrade}
            disabled={isUpgrading}
            className="mt-2 w-full px-3 py-1 text-xs bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors disabled:opacity-50"
          >
            {isUpgrading
              ? 'Processing...'
              : status === 'active_until_period_end' || status === 'cancelled'
                ? 'Resubscribe'
                : 'Upgrade to Pro'}
          </button>
        )}
      </div>
    </div>
  );
};
